/*
===============================================================================================================
                                 Copyright 2022-2022, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import getEnvVar from '@/utilities/environment-variable';

const getTiersMapping = () => {
  const TIERS_API_KEY = getEnvVar('REACT_APP_TIERS_API_KEY');
  return {
    1: {
      CONSUMER_CHARGE_ACCOUNT: getEnvVar(
        'REACT_APP_TIER_1_CONSUMER_CHARGE_ACCOUNT',
      ),
      MLID: getEnvVar('REACT_APP_TIER_1_MLID'),
      API_KEY: TIERS_API_KEY,
    },
    2: {
      CONSUMER_CHARGE_ACCOUNT: getEnvVar(
        'REACT_APP_TIER_2_CONSUMER_CHARGE_ACCOUNT',
      ),
      MLID: getEnvVar('REACT_APP_TIER_2_MLID'),
      API_KEY: TIERS_API_KEY,
    },
    3: {
      CONSUMER_CHARGE_ACCOUNT: getEnvVar(
        'REACT_APP_TIER_3_CONSUMER_CHARGE_ACCOUNT',
      ),
      MLID: getEnvVar('REACT_APP_TIER_3_MLID'),
      API_KEY: TIERS_API_KEY,
    },
    4: {
      CONSUMER_CHARGE_ACCOUNT: getEnvVar(
        'REACT_APP_TIER_4_CONSUMER_CHARGE_ACCOUNT',
      ),
      MLID: getEnvVar('REACT_APP_TIER_4_MLID'),
      API_KEY: TIERS_API_KEY,
    },
  };
};

export default getTiersMapping;
